import config from '../config/index'
import {
  ISalesCampaign,
  ISalesCampaignFormData,
  PaginatedSalesCampaign,
  PaginatedSalesCampaignFilterParams,
} from '../pages/sales-campaigns-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config

export const getPaginatedSalesCampaigns = (data: PaginatedSalesCampaignFilterParams) =>
  authRequest.get<MISSING_TYPE, PaginatedSalesCampaign>(`${mainApi}/sales-campaigns`, {
    params: data,
  })

export const getSalesCampaignDetail = (salesCampaignId: number) =>
  authRequest.get<MISSING_TYPE, ISalesCampaign>(`${mainApi}/sales-campaigns/${salesCampaignId}`)

export const createSalesCampaign = (data: ISalesCampaignFormData) =>
  authRequest.post<MISSING_TYPE, ISalesCampaign>(`${mainApi}/sales-campaigns`, data)

export const editSalesCampaign = (salesCampaignId: number, data: ISalesCampaignFormData) =>
  authRequest.put<MISSING_TYPE, ISalesCampaign>(
    `${mainApi}/sales-campaigns/${salesCampaignId}`,
    data,
  )
